__webpack_require__.p = "https://soc.naqdpay.af/";